<template>
  <div class="mb-2 calendar-card">
    <div class="card-text p-2">
      <div class="row">
        <div v-for="(monthYear, i) of monthYears" :key="i" class="month-container" :style="{ width: 100 / noOfMonthsInRow + '%' }" >
          <table
          >
            <thead>
              <tr>
                <th class="text-center month-title" :colspan="weekDays.length">
                  <span v-if="i == 0 && !disableNextYear" class="float-left" style="cursor: pointer; padding-left: 8px" @click="nextMonth">
                    <i class="arrow left"></i>
                  </span>
                  {{ displayMonthYear(monthYear) }}
                  <span v-if="((noOfMonthsInRow == 1 && i == 0) || (noOfMonthsInRow == 2 && i == 1)) && !disablePrevYear"
                  class="float-right" style="cursor: pointer; padding-right: 8px" @click="previousMonth">
                    <i class="arrow right"></i>
                  </span>
                </th>
              </tr>
              <tr>
                <th v-for="(weekDay, i) of weekDays" :key="i" class="day-header text-center">
                  {{ weekDay }}
                </th>
              </tr>
            </thead>
            <tbody
            >
              <tr v-for="(daysOfWeek, i) of weekWiseDays(monthYear)" :key="i"
                :id="`atlantis-deal-${i}`"
                v-b-tooltip="isMobile ? null : {html: true, title: dealsHtml, placement: 'right', variant: 'info', customClass: 'more-date', trigger: 'hover'}"
              >
                <td
                  v-for="(day, j) of daysOfWeek"
                  :key="j"
                  class="text-center"
                  :title="isHoliday(day)"
                  :class="{
                    available: isAvailable(day) ? true : false,
                    atlantis: hasAtlantisDeal(day) && isOdysseySite,
                    'start-date': isStartDate(day),
                    'end-date': isEndDate(day),
                    'under-selection': isUnderSelection(
                      day
                    ),
                    holiday: !!isHoliday(day) && !hasAtlantisDeal(day),
                    today: isToday(day)
                  }"
                  @click="isAvailable(day)  ? selectDate(day) : null"
                  @mouseenter="isAvailable(day) ? enterDate(day) : null"
                  @mouseover="hoverDate(day, `atlantis-deal-${i}`)"
                >
                  <div v-if="day">
                    {{ day.format("D") }}
                    <!-- <div class="price-text">
                      {{ dayPrice(day) }}
                    </div> -->
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- <tooltip-more-deal :listDeals="atlantisDealDay" targetId="atlantis-tooltip" v-if="showTooltip"/> -->
        </div>
      </div>
      <div class="d-flex flex-row">
        <ul class="reference-list d-flex p-0 align-self-center m-0" style="color: black;">
          <li class="d-flex">
            <div class="reference holiday m-1"></div>
            {{ $t("calendar.holiday") }}
          </li>
          <li class="d-flex" v-if="isFCLAgent">
            <div class="reference atlantis m-1"></div>
            {{ $t("calendar.atlantis") }}
          </li>
        </ul>
        <div class="flex-fill m-1" :class="{ 'm-1': type !== 'side' }">
          <button
            class="btn btn-secondary btn-sm btn-block"
            @click="clearDatesSelection"
            :disabled="selectionDate1 == null ? true : false">
            {{ $t("calendar.clear") }}
          </button>
        </div>
        <div class="flex-fill m-1">
          <button class="btn btn-primary btn-sm btn-block" @click="finalizeSelection" :disabled="selectionDate1 && selectionDate2 ? false : true">
            {{ $t("calendar.continue") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import TemplateDatepicker from './TemplateDatepickerRange';

require('dayjs/locale/he');
require('dayjs/locale/ru');
require('dayjs/locale/ar');

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

export default {
  name: 'DatepickerRange',
  mixins: [TemplateDatepicker],
  components: {
    // TooltipMoreDeal: () => import('@/components/atoms/tooltipMoreDeal/TooltipMoreDealTheme0'),
  },
};
</script>

<style scoped>
.calendar-body .month-title {
  color: black;
}
.calendar-body {
  position: absolute;
  top: 50px;
  z-index: 10;
}
.calendar-card {
  min-width: 250px;
}
.month-container {
  padding: 10px;
}

.month-container table {
  width: 100%;
  margin-bottom: 10px;
}

.month-container td {
  color: #c3ceda;
  pointer-events: none;
  cursor: default;
}

.today {
  color: #95a5b9;
  background-color: #ebf0f1;
}

.month-container .day-header {
  color: #0db04b;
}

.month-container td.start-date,
.month-container td.under-selection {
  background-color: #0db04b !important;
  color: #fff !important;
}
.month-container td.start-date div {
  border-bottom-right-radius: 20px;
  border-top-right-radius: 20px;
  background-color: #0db04b !important;
}
.month-container td.start-date {
  background-color: #c2ebd2 !important;
}
.month-container td.end-date div {
  border-bottom-left-radius: 20px;
  border-top-left-radius: 20px;
  background-color: #0db04b !important;
}
.month-container td.end-date {
  background-color: #c2ebd2 !important;
}

.month-container td.available {
  pointer-events: all;
  background-color: #c2ebd2;
  color: #000;
  cursor: pointer;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}

.reference.available,
.month-container td.available {
  pointer-events: all;
  background-color: #e0efff;
  color: #000;
  cursor: pointer;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  /* background-image: linear-gradient(-45deg, #e0efff 65%, #0db04b 35%); */
  /* background-image: linear-gradient(-45deg, #b6ddff, #fff, #b6ddff); */
  /* border-radius: 3px; */
}

.month-container td.holiday:after {
  content: "";
  height: 18px;
  left: 0;
  position: absolute;
  top: 0;
  width: 18px;
}
.reference.holiday,
.month-container td.holiday:after {
  background-image: url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDY5LjU1IDY5LjU1Ij48ZGVmcz48c3R5bGU+LmNscy0ye2ZpbGw6I2ZmZn08L3N0eWxlPjwvZGVmcz48cGF0aCBkPSJNNjkuNTUgMCAwIDY5LjU1VjBoNjkuNTVabTAgMCIgc3R5bGU9ImZpbGw6IzAxNzJkZiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTkuNzQgMjUuNDFhNi4xOCA2LjE4IDAgMCAxIDEuNDgtMS4xNSAyLjczIDIuNzMgMCAwIDEgMS4zNC0uMzMgMi42NSAyLjY1IDAgMCAxIDEuMjkuNCA2LjgyIDYuODIgMCAwIDEgMS4zMSAxLjA2bDYuMTEgNi4xMWExMi43NyAxMi43NyAwIDAgMCAyLjQxIDEuOSAxNC44IDE0LjggMCAwIDAgMi40NCAxLjIxTDIzLjcyIDM3YTUgNSAwIDAgMS0xLjM3LS41OSAxMi4yOSAxMi4yOSAwIDAgMS0xLjI3LS44NmMtLjQ0LS4zNS0uODctLjcyLTEuMy0xLjExYTcuNDYgNy40NiAwIDAgMSAuODEgMS42IDUuMTkgNS4xOSAwIDAgMSAuMzIgMS45NiA0LjI3IDQuMjcgMCAwIDEtLjQ0IDEuODkgNi41MiA2LjUyIDAgMCAxLTEuMjYgMS43bC0xLjA3IDEuMDEtMi4yMS0yLjIxIDEuMzEtMS4zYTQuNCA0LjQgMCAwIDAgMS0xLjg3IDQuNzUgNC43NSAwIDAgMCAuMS0xLjkxIDUuNDYgNS40NiAwIDAgMC0uNjQtMS44MSA3Ljg3IDcuODcgMCAwIDAtMS4yOS0xLjY4bC0zLjc2LTMuNzZhMSAxIDAgMCAwLS41OS0uMzUuOS45IDAgMCAwLS42NC4zNWwtMi4xNCAyLjE4LTIuMTgtMi4xOVpNMzAuNTIgOWwtMS4xNyAxLjE3TDQwIDIwLjc5bC0yLjYzIDIuNjEtMTAuNjUtMTAuNjUtNC44NCA0Ljg0IDEwLjY0IDEwLjY1LTIuNjIgMi42Mi0xMC42Mi0xMC42Mi0xLjIxIDEuMjEtMi4xOS0yLjE5TDI4LjM0IDYuODFaIi8+PC9zdmc+);
  background-position: 0 0;
  background-repeat: no-repeat;
}

.month-container td.atlantis:after {
  content: "";
  height: 18px;
  left: 0;
  position: absolute;
  top: 0;
  width: 18px;
}
.reference.atlantis,
.month-container td.atlantis:after {
    background-image: url(data:image/png;base64,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);
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: cover;
}

.month-container td .price-text {
  font-size: 9px;
}

.month-container table {
  width: 100%;
}

.month-container th,
.month-container td > div {
  padding: 5px;
}
.month-container td {
  padding: 0;
  position: relative;
}

.month-title {
  font-weight: bolder;
}

.arrow {
  border: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
}

.arrow.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.arrow.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}
.reference-list li {
  list-style: none;
}

.reference {
  width: 18px;
  height: 18px;
}

</style>

<style>
  .more-date .tooltip-inner {
    max-width: 550px;
  }
  .display-flex {
    display: flex;
  }
  .date-range, .night-box, .name-box, .price-box {
    padding: 0.25rem 0.8rem;
  }
  .date-range, .night-box, .name-box {
    font-size: 12px;
  }
  .date-range {
    width: 160px;
    -moz-text-align-last: justify;
    text-align-last: justify;
    background-color: #313232c2;
    color: #fff;
  }
  .price-box {
    text-align: center;
    font-size: 14px;
    width: 80px;
    background-color: #313232c2;
    color: #fff;
  }
  .name-box {
    text-align: center;
    width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    background-color: #313232c2;
    color: #fff;
  }
  .night-box{
    text-align: center;
    background-color: #313232c2;
    color: #fff;
    width: 70px;
  }

</style>
